import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 検索可能な病院一覧
 *
 * 検索可能な病院一覧を返す
 */
export class SelectableHospital implements APIRequest<Monitaro.SelectableHospitalResponse> {
  response: Monitaro.SelectableHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/hospitals/selectable`
  }
}

/**
 * 担当病院一覧
 *
 * 担当病院の一覧を表示する
 */
export class FetchHospital implements APIRequest<Monitaro.FetchHospitalResponse> {
  response: Monitaro.FetchHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/hospitals`
  }
}

/**
 * 病院データの取得
 *
 * 病院データの詳細情報を取得する
 */
export class GetHospital implements APIRequest<Monitaro.GetHospitalResponse> {
  response: Monitaro.GetHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(hospital: string) {
    this.path = `/hospitals/${hospital}`
  }
}

/**
 * 担当病院の更新
 *
 * 担当病院・エリア・病院向け提出書類の更新
 * 担当病院IDとそれに紐づくエリアID、提出書類の追加/削除情報を保存する
 * 同じ病院が指定された場合、古いデータにleaved_atを付与して新しいデータを保存する
 */
export class PostHospital implements APIRequest<Monitaro.PostHospitalResponse> {
  response: Monitaro.PostHospitalResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.HospitalRequest
  constructor(hospital: string, params: Monitaro.HospitalRequest) {
    this.params = params
    this.path = `/hospitals/${hospital}`
  }
}

/**
 * 担当病院の削除
 *
 * 担当病院を削除する
 */
export class DeleteHospital implements APIRequest<Monitaro.DeleteHospitalResponse> {
  response: Monitaro.DeleteHospitalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(hospital: string) {
    this.path = `/hospitals/${hospital}`
  }
}
